import React from "react";
import stepsSvg from "./steps.svg";
import styles from "./FooterSteps.module.css";

function FooterSteps(props) {
  const { stage, isFixedCss } = props;

  const isActive = (check) => check === stage;

  return (
    <div
      className={styles.footerStep}
      style={isFixedCss ? { display: "none" } : { position: "fixed" }}
    >
      <img src={stepsSvg} alt="שלבי הרשמה" />
      <div className={styles.stepsNumbers}>
        <div
          className={`${styles.stageNum1} ${
            isActive(1) ? styles.active : null
          }`}
        >
          1
        </div>
        <div
          className={`${styles.stageNum2} ${
            isActive(2) ? styles.active : null
          }`}
        >
          2
        </div>
        <div
          className={`${styles.stageNum3} ${
            isActive(3) ? styles.active : null
          }`}
        >
          3
        </div>
      </div>
    </div>
  );
}

export default FooterSteps;
